module.exports = __webpack_public_path__ + "static/img/homes-three.c839764.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/homes-three.png
// module id = Av5x
// module chunks = 0